import { Layout } from "./Layout";
import { Loader } from "./Loader";

export function CreateOrEditProjectPage({ isEditMode }: { isEditMode?: boolean }): React.ReactNode {
  return <Loader isEditMode={!!isEditMode}>{(data) => <Layout {...data} />}</Loader>;
}
